import '../scss/utils/plugins/_mapbox.scss'

import Mapbox from './components/Mapbox/Mapbox'

new Mapbox({
  container: 'map',
  style: 'mapbox://styles/stiller72/cmgrt3fnm00e301qs6iaf2mkx',
  markerImageUrl: '/assets/images/map_marker@2x.png',
  accessToken: 'pk.eyJ1Ijoic3RpbGxlcjcyIiwiYSI6ImNtZXM0NTFnMzA3Ym4ybXNpM3BndWliZ2IifQ.LJLB8Le_LA501eIFIZ59kg',
})